// extracted by mini-css-extract-plugin
export default {"menu-item":"Menu_menu-item__xcNDi","active":"Menu_active__50F84","icon":"Menu_icon__JtSDT","active-icon":"Menu_active-icon__wvPIq","title":"Menu_title__cMIQW"};